import styled from "styled-components";

export const SpinnerContainer = styled.span<{ $size: number; $color: string }>`
  display: block;
  position: relative;
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  span {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${(props) => `${0.8 * props.$size}px`};
    height: ${(props) => `${0.8 * props.$size}px`};
    margin: ${(props) => `${props.$size / 10}px`};
    border: ${(props) => `${props.$size / 10}px solid #fff`};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props) => props.$color} transparent transparent transparent;
  }
  span:nth-child(1) {
    animation-delay: -0.45s;
  }
  span:nth-child(2) {
    animation-delay: -0.3s;
  }
  span:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
